import { api } from '@/helpers/core'

export default {
	page (queryObject) {
		return api.post('/monitoring/data/page', queryObject)
	},
	export (queryObject) {
		return api.post('/monitoring/data/export', queryObject)
	},
	txRules (id) {
		return api.get('/monitoring/rules/' + id)
	}
}
